import { AxiosInstance } from "axios";
import { ApiService } from "../model/Api.model";
import { ITicketRequest } from "../interface/ticket/ITicketRequests";
import { IWorkFlowResponse } from "../interface/response/IWorkFlowResponse";
import { ITicketRequestMessageRequest } from "../interface/request/ITicketRequestMessageRequest";

enum TicketRequestMessageEnum {
  base = "/"
}

export default class TicketRequestMessageService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/ticket/request/message");
  }

  public postMessage = async (request: ITicketRequestMessageRequest): Promise<IWorkFlowResponse> => await this.POST(TicketRequestMessageEnum.base, request);
  public getMessages = async (ticketRequestId: number): Promise<ITicketRequest> => await this.GET(`${TicketRequestMessageEnum.base}?ticketRequestId=` + ticketRequestId);
}
